import { createSelector } from 'reselect';
import { KEY } from './';
import { GlobalState } from 'store/types';
import { Client } from './types';

const getClientsState = (state: GlobalState) => state[KEY];

const selectClients = createSelector(getClientsState, (clients) => clients.clients);

const selectClientId = createSelector(getClientsState, (clients) => clients.clientId);

const selectClient = createSelector(getClientsState, (clients) => {
  const client: Client | undefined = clients.clients.find((c) => c.id === clients.clientId);
  return client;
});

const selectAction = createSelector(getClientsState, (state) => state.action);

const selectPending = createSelector(getClientsState, (clients) => clients.action.pending);

const selectError = createSelector(getClientsState, (clients) => clients.action.error);

export const selectors = {
  selectClients,
  selectClientId,
  selectClient,
  selectAction,
  selectPending,
  selectError
};
